import { render, staticRenderFns } from "./MobileColumns.vue?vue&type=template&id=6ddfbcfc&"
import script from "./MobileColumns.vue?vue&type=script&lang=js&"
export * from "./MobileColumns.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports